import { TextField } from "@bps/fluent-ui";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { ConfigValueInputProps } from "./";

interface StringConfigValueInputProps extends ConfigValueInputProps {}

export const StringConfigValueInput = ({
  value,
  onUpdate,
  isReadOnly
}: StringConfigValueInputProps) => {
  const { data: hasWritePermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementWrite
  );

  return (
    <TextField
      value={value}
      onChange={(e, value) => onUpdate(value)}
      disabled={isReadOnly || !hasWritePermission}
      title={!hasWritePermission ? NO_ACTION_PERMISSION : undefined}
    />
  );
};
